import { type UpdatedContractOverviewData } from "./redux/types";
import { redirectToUrl } from "../utils/url/urlUtils";

export function navigateToProductContract(overview: UpdatedContractOverviewData[], productDesignation: string) {
  const contractsForProduct = overview.filter((contract) => contract.designation === productDesignation);

  if (contractsForProduct.length === 1) {
    redirectToUrl(contractsForProduct[0].detailsUrl);
  } else if (contractsForProduct.length > 1) {
    const materialNo = contractsForProduct[0].materialNumber;
    redirectToUrl(`/my-account/contractOverview?highlight=${materialNo}`);
  } else {
    redirectToUrl("/my-account/contractOverview");
  }
}
